import React from 'react'

export const IconTwitter = () => {
  return (
    <svg width="26" height="23" viewBox="0 0 26 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.0708 0.386719H23.8413L15.6039 9.80153L25.2945 22.613H17.7068L11.7639 14.8429L4.96378 22.613H1.19102L10.0017 12.5428L0.70546 0.386719H8.48579L13.8577 7.48886L20.0708 0.386719ZM18.7475 20.3562H20.8368L7.35054 2.525H5.10854L18.7475 20.3562Z"
        fill="black"
      />
    </svg>
  )
}
